import React, { Fragment } from "react";
import Measure from "../Measure/Measure";
import IdentifyOptions from "./Results/Identify/IdentifyOptions";
import { useSelector } from "react-redux";
import Bookmarks from "../Bookmarks/Bookmarks";
import Markup from "../Markup/Markup";
import QueryFilter from "../queryFilter/QueryFilter";
import Print from "../Print/Print";
import Reports from "../Reports/Reports";
import EditingOptions from "../Editing/EditingOptions";
import DragNDrop from "../DragNDrop/DragNDrop";
import EditRelatedRecords from "../Editing/EditRelatedRecords";
import PlotCoordinates from "../PlotCoordinates/PlotCoordinates";

export const Options = () => {
    const tool = useSelector((state) => state.toolSelect.tool);
    const layerOptions = useSelector((state) => state.layerOptions.layerId);
    const bufferFeatures = useSelector((state) => state.identifyOptions.featuresToBuffer);

    return (
        <Fragment>
            {tool === "query" ? (
                <QueryFilter />
            ) : tool === "measure" ? (
                <Measure />
            ) : tool === "bookmarks" ? (
                <Bookmarks />
            ) : tool === "reports" ? (
                <Reports />
            ) : tool === "edit" ? (
                <EditingOptions />
            ) : tool === "editrelatedrecord" ? (
                <EditRelatedRecords />
            ) : tool === "print" ? (
                <Print />
            ) : tool === "markup" ? (
                <Markup />
            ) : tool === "addLayer" ? (
                <DragNDrop />
            ) : tool === "identify" || bufferFeatures.length > 0 ? (
                // IdentifyOption will populate if other tools are closed (undefined)
                //   if features have been selected to buffer
                //   this allows the user to change tool after selecting features and
                //   return to the buffer options
                <IdentifyOptions />
            ) : tool === "plotCoordinates" ? (
                <PlotCoordinates />
            ) : (
                <div />
            )}
        </Fragment>
    );
};

export default Options;
